/**
 * <Linkify /> — turns bare URLs inside a string into clickable anchors that
 * open in a new tab. Also handles common email addresses.
 *
 * Zero dependencies, no dangerouslySetInnerHTML. Splits the text on regex
 * matches and returns a React fragment mixing string chunks with <a> tags.
 */
import React from "react";

// Matches http(s)://…, www.…, and email addresses. The trailing punctuation
// character is kept out of the URL so "http://foo.com." doesn't include the dot.
const URL_RE = /((?:https?:\/\/|www\.)[^\s<]+|[\w.+-]+@[\w-]+\.[\w.-]+)/gi;

function toHref(match) {
  if (match.includes("@") && !match.startsWith("http")) return `mailto:${match}`;
  if (match.startsWith("www.")) return `https://${match}`;
  return match;
}

// Strip trailing punctuation (.,;:!?)]}) that people typically type after a URL.
function trimTrailingPunct(m) {
  const stripped = m.replace(/[.,;:!?)\]}>]+$/, "");
  const tail = m.slice(stripped.length);
  return [stripped, tail];
}

export default function Linkify({ text, className }) {
  if (!text) return null;
  const nodes = [];
  let lastIndex = 0;
  let match;
  URL_RE.lastIndex = 0;
  let key = 0;
  while ((match = URL_RE.exec(text)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(text.slice(lastIndex, match.index));
    }
    const [url, tail] = trimTrailingPunct(match[0]);
    nodes.push(
      <a
        key={key++}
        href={toHref(url)}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="underline hover:opacity-80"
        style={{ color: "var(--wofy-primary)" }}
        onClick={(e) => e.stopPropagation()}
      >
        {url}
      </a>
    );
    if (tail) nodes.push(tail);
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) nodes.push(text.slice(lastIndex));
  return <span className={className}>{nodes}</span>;
}
